export const COLLABORATION_UNAVAILABLE_MESSAGE =
  "Colaboracao em tempo real ainda nao esta disponivel neste ambiente.";

type FirebaseConfig = {
  apiKey: string;
  projectId: string;
  storageBucket?: string;
  [key: string]: unknown;
};

const parseFirebaseConfig = (): FirebaseConfig | null => {
  const rawConfig = import.meta.env.VITE_APP_FIREBASE_CONFIG;

  if (!rawConfig) {
    return null;
  }

  try {
    const parsed = JSON.parse(rawConfig) as Partial<FirebaseConfig>;

    if (
      typeof parsed.apiKey === "string" &&
      parsed.apiKey.trim() &&
      typeof parsed.projectId === "string" &&
      parsed.projectId.trim()
    ) {
      return parsed as FirebaseConfig;
    }
  } catch (error) {
    console.warn("[collab] Invalid VITE_APP_FIREBASE_CONFIG.", error);
  }

  return null;
};

export const FIREBASE_CONFIG = parseFirebaseConfig();

export const isCollaborationConfigured = () => {
  return (
    import.meta.env.VITE_APP_ENABLE_COLLABORATION === "true" &&
    Boolean(import.meta.env.VITE_APP_WS_SERVER_URL?.trim()) &&
    Boolean(FIREBASE_CONFIG)
  );
};
